import { createFileRoute, Navigate } from "@tanstack/react-router";

import OrganizationDetail from "../pages/Organizations/OrganizationDetail";
import { useAuth } from "../context/AuthContext";
import { RequireAuth } from "../utils/RequireAuth";

export const Route = createFileRoute("/_shell/organizations/$orgId")({
  component: OrganizationDetailRoute,
});

function OrganizationDetailRoute() {
  const auth = useAuth();

  return (
    <RequireAuth>
      {auth.canManageOrganizations === true ? <OrganizationDetail /> : <Navigate to="/" replace />}
    </RequireAuth>
  );
}
